import TrackingDetails from '../../../components/tables/trackingDetails/TrackingDetails';
import { getDynamicSelectData } from '../../../utils/api/data';
import Sidebar from '../../../components/sidebar/Sidebar';
import Map from '../../../components/tracking/map/Map';
import NavBar from '../../../components/navbar/NavBar';
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import React, { useState, useEffect, useMemo } from 'react';
import { config } from "../../../config/Constants";
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import Cookies from 'js-cookie';
import Axios from 'axios';
import './trackingmap.css';

const TrackingMap = () => {
  const defaultCoordinates = [{ LATITUDE: 40.758701, LONGITUDE: -111.876183 }];
  const [coordinates, setCoordinates] =  useState(defaultCoordinates);
  const [selectFilter, setSelectFilter] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  const [trackingDetails, setTrackingDetails] = useState([]);
  const [reportData, setReportData] = useState();
  const [options, setOptions] = useState([]);

  const getReportData = async(value) => {
    if (Cookies.get('cp-cn') !== 'GTMS-CP') {
      const response = await getDynamicSelectData({
        selectValues: 'TRACKING_DATE, BOL, CONTAINER, LONGITUDE, LATITUDE, EVENT', 
        tableName: 'INGESTION.MANUAL_OCEAN_TRACKING ',
        whereField: ["CUSTOMER"], 
        whereOperators:["="], 
        whereValue: [Cookies.get('cp-cn')], 
        orderBy: "TRACKING_DATE ASC",
        db: 'SF'
      });
      setReportData({data: response})
    }
    if (Cookies.get('cp-cn') === 'GTMS-CP') {
      const response = await Axios.get(config.url.GET_REPORT, {
      params: {
        reportName: 'oceanTracking',
        companyName: Cookies.get("cp-cn"),
      },
    });
      setReportData({data: response.data.report})
    };
  }

  const bolList = useMemo(() => {
    return [...new Set(reportData?.data?.map(item => item.BOL))] || [];
  }, [reportData]);

  const containerList = useMemo(() => {
    return [...new Set(reportData?.data?.map(item => item.CONTAINER))] || [];
  }, [reportData]);

  useEffect(() => { getReportData(); }, []);
    
  const handleSelectFilter = (event) => {
    const value = event.target.value;
    setSelectFilter(value);

    const newOptions = value === 'BOL_NUMBER' ? bolList : containerList;
    setOptions(newOptions);
    setSelectedOption(null);
  };

  const getCoordinates = () => {
    if (!selectedOption || !selectFilter) return null;
    const key = selectFilter === 'BOL_NUMBER' ? 'BOL' : 'CONTAINER';
    const matches = reportData.data.filter(item => item[key] === selectedOption);
    if (matches.length === 0) return null;

    return matches.map(item => ({
      LATITUDE: item.LATITUDE,
      LONGITUDE: item.LONGITUDE,
      DATE: item.TRACKING_DATE,
      STATUS: item.EVENT             
    }));
  };

  const submit = () => {
    let coordinate = getCoordinates()
    setCoordinates(coordinate ?? defaultCoordinates);
    setTrackingDetails(coordinate ?? [])
  }

  return (
    <div className='LandingPage'>
    <div className="LandingPageContainer">
      <NavBar/>
      <Sidebar/>
      <div className="trackingMapPageContent">
        <div className="trackingMapTop">
          <div className="trackingMapTitle">
            <div className="MapTrackingTitle">
              <h1>Ocean Tracking</h1>
            </div>
          </div>
        </div>
        <div className="trackingMapMid">
          <Map coordinates={coordinates}/>
        </div>
        <div className="trackingMapBottom">
          <div className="trackingMapBotLeft">
            <div className="trackingMapBotLeftTop">
              <h3>Filter By:</h3>
            </div>
            <div className="trackingMapBotLeftMid">
              <div className="MapSelectControls">
                <div className="selectFilter">
                  <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <InputLabel>Filter By</InputLabel>
                    <Select id="selectFilter" label="selectFilter" value={selectFilter} onChange={handleSelectFilter}>
                      <MenuItem value={'CONTAINERS'}>Container</MenuItem>
                      <MenuItem value={'BOL_NUMBER'}>GTMS BOL</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="selectValue">
                  <Autocomplete
                    size='small'
                    sx={{ m: 1, minWidth: 200 }}
                    options={options}
                    getOptionLabel={(option) => option} 
                    renderInput={(params) => <TextField {...params} label="Select Value" />}
                    value={selectedOption} 
                    onChange={(event, newValue) => setSelectedOption(newValue)}
                    disabled={!selectFilter}
                  />
                </div>
                <div className="submitMapTracking">
                  <Button
                    variant="contained"
                    onClick={submit}>
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </div>
          <div className="trackingMapBotRight">
            <div className="trackingDetailsTop"></div>
            <div className="trackingDetailsMid">
              <TrackingDetails data = {trackingDetails}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default TrackingMap